import { useState } from 'react';
import { submitTsrEnquiry } from '../utils/api';

export default function useTsrEnquirySubmit({ successMessage = 'Thank you! We will contact you shortly.' } = {}) {
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const clearMessage = () => {
    if (message.text) {
      setMessage({ type: '', text: '' });
    }
  };

  const handleSubmit = async (payload, { onSuccess } = {}) => {
    if (submitting) return false;

    setSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      await submitTsrEnquiry(payload);
      setMessage({ type: 'success', text: successMessage });
      if (onSuccess) {
        onSuccess();
      }
      return true;
    } catch (err) {
      setMessage({
        type: 'error',
        text: err.message || 'Unable to send your request. Please try again.',
      });
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  return {
    submitting,
    message,
    clearMessage,
    handleSubmit,
    setMessage,
  };
}
